/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * DELETE /distributors/{id}
 * @export
 * @interface DeleteDistributorSuccessResponse
 */
export interface DeleteDistributorSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteDistributorSuccessResponse
     */
    status: number;
    /**
     * エラーメッセージ。原則英語。
     * @type {string}
     * @memberof DeleteDistributorSuccessResponse
     */
    message: string;
}

export function DeleteDistributorSuccessResponseFromJSON(json: any): DeleteDistributorSuccessResponse {
    return DeleteDistributorSuccessResponseFromJSONTyped(json, false);
}

export function DeleteDistributorSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteDistributorSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
    };
}

export function DeleteDistributorSuccessResponseToJSON(value?: DeleteDistributorSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

